export default __webpack_public_path__ + "static/media/punchclock.61189e7c.jpg";